import BaseService from '@/scripts/services/base/base.service'

export default class EntityService extends BaseService {
    constructor() {
        super('Entity')
    }

    //Entity Region
    updateEntityStatus(entityId) {
        return this.getRequest('UpdateEntityStatus', { entityId })
    }

    listAllEntityTypes() {
        return this.getRequest('ListAllEntityTypes')
    }

    listAllJobRoles() {
        return this.getRequest('ListAllJobRoles')
    }

    listSecretariesToUserRegister() {
        return this.getRequest('ListSecretariesToUserRegister')
    }
    //End of Entity Region

    //Secretary Region
    createSecretary(secretary, file) {
        let formData = new FormData()
        formData.append('secretary', JSON.stringify(secretary))
        formData.append('file', file)
        return this.postRequest('CreateSecretary', formData)
    }

    editSecretary(secretary, file) {
        let formData = new FormData()
        formData.append('secretary', JSON.stringify(secretary))
        formData.append('file', file)
        return this.postRequest('EditSecretary', formData)
    }

    listSecretaries(filters) {
        return this.postRequest('ListAllSecretaries', filters)
    }

    countSecretaries(filters) {
        return this.postRequest('CountSecretaries', filters)
    }

    getSecretaryById(id) {
        return this.getRequest('FindSecretaryById', { id })
    }

    listAllActiveSecretaries(id) {
        return this.getRequest('ListAllActiveSecretaries', { id })
    }
    //End of Secretary Region

    //Fund Region
    createFund(fund) {
        let formData = new FormData()
        formData.append('fund', JSON.stringify(fund))
        return this.postRequest('CreateFund', formData)
    }

    editFund(fund) {
        let formData = new FormData()
        formData.append('fund', JSON.stringify(fund))
        return this.postRequest('EditFund', formData)
    }

    listFunds(filters) {
        return this.postRequest('ListAllFunds', filters)
    }

    countFunds(filters) {
        return this.postRequest('CountFunds', filters)
    }

    getFundById(id) {
        return this.getRequest('FindFundById', { id })
    }

    listAllActiveFunds(id) {
        return this.getRequest('ListAllActiveFunds', { id })
    }
    //End of Fund Region

    //Institution Region
    createInstitution(institution, file) {
        let formData = new FormData()
        formData.append('institution', JSON.stringify(institution))
        formData.append('file', file)
        return this.postRequest('CreateInstitution', formData)
    }

    editInstitution(institution, file) {
        let formData = new FormData()
        formData.append('institution', JSON.stringify(institution))
        formData.append('file', file)
        return this.postRequest('EditInstitution', formData)
    }

    listInstitutions(filters) {
        return this.postRequest('ListAllInstitutions', filters)
    }

    countInstitutions(filters) {
        return this.postRequest('CountInstitutions', filters)
    }

    checkIfInstitutionAlreadyExistsAndIfIsTrueReturn(institutionDocument) {
        return this.getRequest(
            'CheckIfInstitutionAlreadyExistsAndIfIsTrueReturn',
            { institutionDocument }
        )
    }

    getInstitutionById(id) {
        return this.getRequest('FindInstitutionById', { id })
    }
    //End of Institution Region

    //Council Region
    createCouncil(council, file) {
        let formData = new FormData()
        formData.append('council', JSON.stringify(council))
        formData.append('file', file)
        return this.postRequest('CreateCouncil', formData)
    }

    editCouncil(council, file) {
        let formData = new FormData()
        formData.append('council', JSON.stringify(council))
        formData.append('file', file)
        return this.postRequest('EditCouncil', formData)
    }

    countCouncil(filters) {
        return this.postRequest('CountCouncils', filters)
    }

    getCouncilById(id) {
        return this.getRequest('FindCouncilById', { id })
    }

    listCouncils(filters) {
        return this.postRequest('ListAllCouncils', filters)
    }

    listAllActiveCouncils() {
        return this.getRequest('ListAllActiveCouncils')
    }

    countCouncils(filters) {
        return this.postRequest('CountCouncils', filters)
    }

    getCouncilConfig(councilId) {
        return this.getRequest('GetCouncilConfig', { councilId })
    }

    saveCouncilConfig(
        councilConfig,
        backgroundImage,
        lightLogoImage,
        darkLogoImage,
        shareImage,
        faviconImage
    ) {
        let formData = new FormData()
        formData.append('councilConfig', JSON.stringify(councilConfig))
        let sentFiles = ''
        if (backgroundImage) {
            formData.append('files', backgroundImage)
            sentFiles += 'backgroundImageFile,'
        }
        if (lightLogoImage) {
            formData.append('files', lightLogoImage)
            sentFiles += 'lightLogoImageFile,'
        }
        if (darkLogoImage) {
            formData.append('files', darkLogoImage)
            sentFiles += 'darkLogoImageFile,'
        }
        if (shareImage) {
            formData.append('files', shareImage)
            sentFiles += 'shareImageFile,'
        }
        if (faviconImage) {
            formData.append('files', faviconImage)
            sentFiles += 'faviconImageFile,'
        }
        formData.append('sentFiles', sentFiles)
        return this.postRequest('SaveCouncilConfig', formData)
    }

    publishCouncil(councilId) {
        return this.getRequest('PublishCouncil', { councilId })
    }

    unpublishCouncil(councilId) {
        return this.getRequest('UnpublishCouncil', { councilId })
    }
    //End of Council Region

    saveSignatureCouncil(id, imgBase64){
        return this.postRequest('saveSignatureCouncil', {id, imgBase64})
    }
}
